export const MODULE_NAME = '3p-connect';
export const path = `/${MODULE_NAME}`;
